import { render, staticRenderFns } from "./ElDialog.vue?vue&type=template&id=66e25122"
import script from "./ElDialog.vue?vue&type=script&lang=js"
export * from "./ElDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports